// DOM Content Loaded
document.addEventListener("DOMContentLoaded", function () {

    /**
     * Select elements in the DOM
     */

    const scrollToFirstSection = document.querySelector('.js-scroll');

    if (scrollToFirstSection) {
        scrollToFirstSection.addEventListener('click', () => {
            window.scrollTo({
                top: window.innerHeight,
                behavior: 'smooth'
            });
        });
    }

});
